var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___NUp4WW",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___NUp4WW",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___NUp4WW",
  "eb": "FavoritesChannelListContent.module__favoriteItem___NUp4WW",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___NUp4WW",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___NUp4WW",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___NUp4WW",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___NUp4WW",
  "H": "FavoritesChannelListContent.module__avatarContainer___NUp4WW",
  "my": "FavoritesChannelListContent.module__avatar___NUp4WW",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___NUp4WW",
  "XQ": "FavoritesChannelListContent.module__channelBadge___NUp4WW",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___NUp4WW",
  "QC": "FavoritesChannelListContent.module__displayName___NUp4WW",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___NUp4WW",
  "af": "FavoritesChannelListContent.module__categoryItem___NUp4WW",
  "Yq": "FavoritesChannelListContent.module__categoryContent___NUp4WW",
  "yb": "FavoritesChannelListContent.module__categoryName___NUp4WW",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___NUp4WW",
  "wp": "FavoritesChannelListContent.module__categoryActions___NUp4WW",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___NUp4WW",
  "It": "FavoritesChannelListContent.module__categoryAddButton___NUp4WW",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___NUp4WW",
  "NP": "FavoritesChannelListContent.module__navigationContainer___NUp4WW",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___NUp4WW",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___NUp4WW",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___NUp4WW",
};

module.exports = exports;
